import { db, sleep } from '../utils.mjs'
import {getChainFromId} from './config.mjs'

function collectInjectedProviders() {
  const out = []
  const seen = new Set()
  const pushUnique = (p) => {
    if (!p || typeof p.request !== 'function') return
    if (seen.has(p)) return
    seen.add(p)
    out.push(p)
  }
  try {
    const eth = window.ethereum
    if (eth && Array.isArray(eth.providers) && eth.providers.length) {
      eth.providers.forEach(pushUnique)
    }
    pushUnique(eth)
  } catch (_e) {
    void _e
  }
  try {
    pushUnique(window.bitkeep && window.bitkeep.ethereum)
  } catch (_e) {
    void _e
  }
  try {
    pushUnique(window.avewallet && window.avewallet.ethereum)
    pushUnique(window.aveWallet && window.aveWallet.ethereum)
    pushUnique(window.ave && window.ave.ethereum)
  } catch (_e) {
    void _e
  }
  return out
}

export function listInjectedProviders() {
  return collectInjectedProviders()
}

export function isAveInjectedProvider(provider) {
  if (!provider || typeof provider !== 'object') return false
  if (provider.isAveWallet || provider.isAVEWallet || provider.isAVE || provider.isAve) return true
  if (typeof provider.providerName === 'string' && /avewallet|ave\.ai/i.test(provider.providerName)) return true
  const wn = String(provider.walletName || '')
  if (wn && /avewallet|ave\.ai|ave wallet/i.test(wn)) return true
  return false
}

export function inferWalletKeyFromProvider(provider) {
  if (!provider) return ''
  const ua = (typeof navigator !== 'undefined' ? navigator.userAgent : '').toLowerCase()
  if (
    isAveInjectedProvider(provider) ||
    /ave\.ai|avewallet|ave\s*wallet/i.test(ua) ||
    (typeof window !== 'undefined' && (window.avewallet || window.aveWallet || window.ave))
  ) return 'ave'
  if (provider.isTokenPocket) return 'tokenPocket'
  if (provider.isBitKeep || provider.isBitgetWallet) return 'bitget'
  if (provider.isOkxWallet || provider.isOKExWallet) return 'okx'
  if (provider.isCoinbaseWallet) return 'coinbase'
  if (provider.isTrust || provider.isTrustWallet) return 'trust'
  if (provider.isMetaMask) return 'metamask'
  return ''
}

export function inferWalletLabelFromProvider(provider) {
  if (!provider) return 'Injected Wallet'
  const key = inferWalletKeyFromProvider(provider)
  if (key === 'ave') return 'AVE Wallet'
  if (key === 'tokenPocket') return 'TokenPocket'
  if (key === 'bitget') return 'Bitget Wallet'
  if (key === 'okx') return 'OKX Wallet'
  if (key === 'coinbase') return 'Coinbase Wallet'
  if (key === 'trust') return 'Trust Wallet'
  if (key === 'metamask') return 'MetaMask'
  return 'Injected Wallet'
}

function persistInjectedWalletLabelIfConfident(provider) {
  try {
    const key = inferWalletKeyFromProvider(provider)
    const label = inferWalletLabelFromProvider(provider)
    if (!key || !label || label === 'Injected Wallet') return
    // 避免自动连接阶段把用户在弹窗里明确选择的标签覆盖掉
    const prevKey = String(db.get('wallet_key', '') || '').trim()
    const prev = String(db.get('wallet_label', '') || '').trim()
    if (prevKey && prevKey !== 'metamask' && prevKey !== 'currentWallet') return
    if (prev && prev !== 'MetaMask' && prev !== 'Injected Wallet') return
    db.set('wallet_key', key)
    db.set('wallet_label', label)
  } catch (_e) {
    void _e
  }
}

export async function getCurrentInjectedProvider() {
  const providers = collectInjectedProviders()
  if (!providers.length) return null
  for (const p of providers) {
    try {
      const accounts = await p.request({ method: 'eth_accounts' })
      if (Array.isArray(accounts) && accounts.length > 0) return p
    } catch (_e) {
      void _e
    }
  }
  // 如果无法直接探测“当前激活钱包”，退回首个可用注入 provider
  return providers[0]
}

export function getProvider(){
  const providers = collectInjectedProviders()
  if (providers.length) return providers[0]
  return (window.bitkeep && window.bitkeep.ethereum) || window.ethereum
}
function getTronWeb(){
  try{
    return window.tronWeb || tronWeb || (tronLink && tronLink.tronWeb)
  }catch(e){
    return 
  }
}
function getTronLink(){
  try{
    return window.tronLink || tronLink
  }catch(e){
    return 
  }
}
export async function getAccountTronWeb(){
  const tronLink = getTronLink()
  const tronWeb = getTronWeb()
  try{
    tronLink && !tronLink.ready && tronLink.request && await tronLink.request({method: 'tron_requestAccounts'})
  }catch(e){
    console.log(e)
  }
  try{
    db.set('wallet_type', 'inject')
    db.set('topic', '')
    return {account: '0x' + tronWeb.defaultAddress.hex.substr(2), chainId: 95500, provider: tronWeb}
  }catch(e){
    console.log(e)
    throw 'can not find tronWeb provider'
  }
}
export async function getAccountInject(chainId, force = false, options = {}) {
  const selectedProvider = options.provider || (options.preferCurrent ? await getCurrentInjectedProvider() : null)
  const provider = selectedProvider || getProvider()
  const fromTron = location.search.indexOf('fromTron') != -1
  const tronWeb = getTronWeb()
  
  if(fromTron || !provider || chainId == 95500 || (window.isBitKeep && tronWeb && tronWeb.defaultAddress && tronWeb.defaultAddress.hex)){
    try{
      return await getAccountTronWeb()
    }catch(e){
      console.warn(e)
    }
  }
  if (!provider) {
    throw 'can not find web3 provider'
  }
  let accounts
  try{
    accounts = await provider.request({ method: 'eth_requestAccounts' });
  }catch(e){
    if(window.okxwallet)
      return await getAccountTronWeb()
  }
  const account = accounts[0]
  if(account.substr(0, 1) == 'T'){
    if(window.okxwallet)
      return await getAccountTronWeb()
    alert("please start with https://hieswap.com/?fromTron")
    throw 'error account'
  }
  let providerChainId = await provider.request({ method: 'eth_chainId' });
  providerChainId = parseInt(providerChainId)
  if(chainId == 95500)
    chainId = providerChainId
  if(providerChainId != chainId && force){
    await provider.request({ method: 'wallet_switchEthereumChain', params: [{chainId: "0x" + chainId.toString(16)}]})
    location.reload()
  }
  else
    chainId = providerChainId
  try {
    if (typeof provider.removeAllListeners === 'function') {
      provider.removeAllListeners()
    }
  } catch (_e) {
    void _e
  }
  if (typeof provider.on === 'function') {
    provider.on('accountsChanged', (_e) => {
      location.reload()
    })
    provider.on('chainChanged', (e) => {
      console.log('chainChanged', e)
      const chainId = e.substr(0, 2) == '0x'? parseInt(e, 16): Number(e)
      if(getChainFromId(chainId)){
        db.set('chainId', chainId)
      }
      location.reload()
    })
  }
  db.set('wallet_type', 'inject')
  /* 避免曾连过 WC 后残留 topic，导致刷新后 syncInjectedAccountIfNeeded 误判为 WC 会话而跳过 eth_accounts */
  db.set('topic', '')
  persistInjectedWalletLabelIfConfident(provider)
  return {account, chainId, provider};
}